(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-01-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.jl-announce[data-countdown-target]').forEach(initCountdown);

    // Barra clicable → baja a la compra del hero
    document.querySelectorAll('.jl-announce [data-jl-goto]').forEach(function (btn) {
      btn.addEventListener('click', function () { goToOffer(btn.closest('.jl-announce')); });
    });

    // Condensar al hacer scroll: en móvil la promo colapsa y solo queda el countdown.
    var stickyBars = document.querySelectorAll('.jl-announce--sticky');
    if (stickyBars.length) {
      var condensed = false, condRaf = null;
      var onScrollCondense = function () {
        if (condRaf) return;
        condRaf = requestAnimationFrame(function () {
          condRaf = null;
          var should = window.pageYOffset > 16;
          if (should !== condensed) {
            condensed = should;
            stickyBars.forEach(function (b) { b.classList.toggle('jl-announce--condensed', should); });
          }
        });
      };
      window.addEventListener('scroll', onScrollCondense, { passive: true });
      onScrollCondense();
    }

    function goToOffer(announce) {
      var target = document.querySelector('[data-jl-offer], .jl-hero__buybox, .jl-hero__cta');
      if (!target) return;
      var headerEl = document.querySelector('.header-wrapper, .shopify-section-header, header');
      var headerH = (headerEl && headerEl.getBoundingClientRect().height) || 0;
      var announceH = (announce && announce.classList.contains('jl-announce--sticky')) ? (announce.getBoundingClientRect().height || 0) : 0;
      var top = window.pageYOffset + target.getBoundingClientRect().top - headerH - announceH - 16;
      window.scrollTo({ top: top < 0 ? 0 : top, behavior: reduce ? 'auto' : 'smooth' });
    }

    function initCountdown(section) {
      var target = parseTarget(section.dataset.countdownTarget);
      if (!target || isNaN(target.getTime())) return;

      var expiredText = section.dataset.expiredText || '';
      var elDays = section.querySelector('[data-days]');
      var elHours = section.querySelector('[data-hours]');
      var elMinutes = section.querySelector('[data-minutes]');
      var elSeconds = section.querySelector('[data-seconds]');
      var elPromo = section.querySelector('.jl-announce__promo');
      var elCountdown = section.querySelector('[data-countdown]');
      var interval;

      function update() {
        var diff = target.getTime() - Date.now();
        if (diff <= 0) {
          clearInterval(interval);
          if (elCountdown) elCountdown.style.display = 'none';
          if (expiredText && elPromo) elPromo.textContent = expiredText;
          section.classList.add('jl-announce--expired');
          return;
        }
        // Si se muestran días, las horas van en módulo 24; si no, horas = total restantes.
        if (elDays) elDays.textContent = String(Math.floor(diff / 86400000));
        if (elHours) elHours.textContent = pad(elDays ? Math.floor(diff / 3600000) % 24 : Math.floor(diff / 3600000));
        if (elMinutes) elMinutes.textContent = pad(Math.floor(diff / 60000) % 60);
        if (elSeconds) elSeconds.textContent = pad(Math.floor(diff / 1000) % 60);
      }

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function parseTarget(s) {
        if (!s) return null;
        return new Date(s.replace(' ', 'T')); // hora local del visitante
      }

      update();
      interval = setInterval(update, 1000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-banda-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jcta]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.3 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-bf-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-jbfq]').forEach(function (root) {
    root.classList.add('jbfq--js');
    var items = [].slice.call(root.querySelectorAll('[data-jbfq-item]'));
    function cierra(o) { o.classList.remove('is-open'); var b = o.querySelector('[data-jbfq-btn]'); if (b) b.setAttribute('aria-expanded', 'false'); }
    items.forEach(function (item) {
      var btn = item.querySelector('[data-jbfq-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var abrir = !item.classList.contains('is-open');
        items.forEach(function (o) { if (o !== item) cierra(o); });
        if (abrir) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
        else { cierra(item); }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-calculo"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jcalc]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.2 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-carta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jcarta]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.15 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-cita"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jcita]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.25 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-como-funciona"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jcf]');
  if (!els.length) return;
  els.forEach(function (root) {
    root.classList.add('jcf--js'); // habilita el colapso (sin JS queda todo abierto)
    // Reveal
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { threshold: 0.12 });
      io.observe(root);
    } else { root.classList.add('is-in'); }
    // Colapsable (efectivo solo en móvil; en desktop el CSS lo fuerza abierto)
    var steps = [].slice.call(root.querySelectorAll('.jcf__step--has'));
    steps.forEach(function (step, i) {
      var btn = step.querySelector('[data-jcf-toggle]');
      if (!btn) return;
      if (i === 0) { step.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); } // primer paso abierto
      btn.addEventListener('click', function () {
        var open = step.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-concentrado"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jconc]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.2 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-cuidamos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jcuid]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.15 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-esencias"] && !Shopify.designMode) return;
  try {
    
(function () {
  function quieto(){ return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  document.querySelectorAll('[data-jes]').forEach(function (sec) {
    if (sec.dataset.jesOn) return; sec.dataset.jesOn = '1';
    var D = sec.dataset;
    /* El test 50/50 de la portada (02-05/10) terminó: fuera el grupo que guardaba en el navegador. */
    try { localStorage.removeItem('jaspe_casa'); } catch(e){}
    var picks = [].slice.call(sec.querySelectorAll('[data-jes-pick]'));
    if (!picks.length) return;
    var cards = picks.map(function(b){ return b.closest('[data-jes-card]'); });
    var q = function(sel){ return sec.querySelector(sel); };
    var grid = q('[data-jes-list]'), barra = q('[data-jes-barra]'), carril = q('[data-jes-packs]');
    var huecos = [].slice.call(sec.querySelectorAll('.jes__hueco[data-k]'));

    /* Los textos vienen de los data-* de la seccion, que si pasan por Liquid y por locales/. */
    function T(k, fb, n){
      var v = D[k];
      if (v == null || v === '') v = fb;
      return n == null ? v : String(v).split('{n}').join(n);
    }
    function num(t){ return parseFloat(String(t || '').replace(/[^0-9,.]/g, '').replace(',', '.')) || 0; }
    /* Mismo formato que el ajuste: 29,95€ o 29,95 € */
    function fmt(v, como){ var s = v.toFixed(2).replace('.', ','); return /\s€/.test(como || '') ? s + ' €' : s + '€'; }

    /* De serie: las seis, una de cada. El de 6 es casi la mitad de los pedidos y quien lo elige se suscribe mas. */
    var seis = picks.map(function(b, i){ return i; }).slice(0, 6);
    while (seis.length < 6) seis.push(seis[seis.length % picks.length]);
    var st = { pack: 6, mode: 'sub', sel: seis.slice(), extra: 0, mem: {} };
    var trio = seis.slice(0, 3), deLaTienda = false;

    function precioDe(p, m){ return m === 'sub' ? (p === 3 ? D.p3sub : D.p6sub) : (p === 3 ? D.p3once : D.p6once); }
    function precio(){ return precioDe(st.pack, st.mode); }
    function veces(i){ return st.sel.filter(function(x){ return x === i; }).length; }
    function nombre(i){ return (picks[i] && picks[i].getAttribute('data-name')) || ''; }
    function falta(){ return st.pack - st.sel.length; }
    function conExtra(t){
      var ex = q('[data-jes-extra]');
      var c = ex ? (parseInt(ex.getAttribute('data-centimos'), 10) || 0) : 0;
      if (!st.extra || !c) return (t || '').trim();
      return fmt(num(t) + st.extra * c / 100, t);
    }

    var arrancado = false;
    function reanima(el, clase){ if (!el) return; el.classList.remove(clase); void el.offsetWidth; el.classList.add(clase); }
    function pon(el, v){
      if (!el || el.textContent === v) return;
      el.textContent = v;
      if (arrancado && !quieto()) reanima(el, 'jes-cambia');
    }
    /* El numero de la pastilla rueda: sube al sumar, baja al quitar. */
    function rueda(el, v){
      if (!el) return;
      var viejo = el.firstElementChild, antes = viejo ? parseInt(viejo.textContent, 10) : 0;
      if (viejo && viejo.textContent === String(v)) return;
      var nuevo = document.createElement('span'); nuevo.textContent = String(v);
      if (arrancado && !quieto()) nuevo.className = v > antes ? 'is-sube' : 'is-baja';
      el.textContent = ''; el.appendChild(nuevo);
    }

    /* El aviso junto al dedo: dice que ha cambiado y, si se puede, deja deshacerlo. */
    var av = q('[data-jes-aviso]'), avT = q('[data-jes-aviso-t]'), avB = q('[data-jes-deshacer]'), avTimer = null, avUndo = null;
    function calla(){ clearTimeout(avTimer); avUndo = null; if (av) av.hidden = true; }
    function avisa(txt, undo){
      /* Con la ficha abierta el aviso de la capsula queda detras del velo: se dice en el pie de la ficha. */
      if (modal && modal.open && mnota){
        clearTimeout(mAviso); mnota.textContent = txt; mnota.classList.add('is-aviso');
        mAviso = setTimeout(function(){ mAviso = null; pintaMadd(); }, 2600);
        return;
      }
      if (!av) return;
      clearTimeout(avTimer); avT.textContent = txt; avUndo = undo || null; avB.hidden = !undo; av.hidden = false;
      avTimer = setTimeout(calla, undo ? 6000 : 3200);
    }
    if (avB) avB.addEventListener('click', function(){ var u = avUndo; calla(); if (u){ u(); render(); } });

    /* ---------- el vuelo: el frasco va de su tarjeta a su hueco ---------- */
    var volando = 0;
    function visible(r){ return r.width > 0 && r.bottom > 0 && r.top < (window.innerHeight || 0); }
    function puedeVolar(i, k){
      if (quieto() || !arrancado || !huecos[k] || (modal && modal.open) || !document.body.animate) return false;
      var f = cards[i] && cards[i].querySelector('.jes__foto');
      return !!f && visible(f.getBoundingClientRect()) && visible(huecos[k].getBoundingClientRect());
    }
    function vuela(i, k){
      var f = cards[i].querySelector('.jes__foto'), h = huecos[k];
      var a = f.getBoundingClientRect(), b = h.getBoundingClientRect(), t = 56;
      var el = document.createElement('span'), bola = document.createElement('i');
      el.className = 'jes__vuelo'; el.setAttribute('aria-hidden', 'true');
      el.style.left = (a.left + a.width / 2 - t / 2) + 'px'; el.style.top = (a.top + a.height / 2 - t / 2) + 'px';
      bola.style.backgroundImage = 'url("' + (picks[i].getAttribute('data-foto') || '') + '")';
      bola.style.backgroundColor = 'color-mix(in srgb, var(--c-lino) 24%, var(--c-marfil-hi))';
      el.appendChild(bola); document.body.appendChild(el);
      var dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
      var fin = Math.max(.3, (b.width - 4) / t), dur = 640;
      /* Dos ejes con curvas distintas: la X avanza pareja y la Y sube un poco antes de caer. Sale un arco, no una recta. */
      el.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + dx + 'px)' }], { duration: dur, easing: 'cubic-bezier(.3, 0, .6, 1)', fill: 'forwards' });
      el.animate([{ opacity: 0 }, { opacity: 1, offset: .12 }, { opacity: 1 }], { duration: dur, fill: 'forwards' });
      var y = bola.animate([
        { transform: 'translateY(0) scale(.5)' },
        { transform: 'translateY(0) scale(1.08)', offset: .16 },
        { transform: 'translateY(' + dy + 'px) scale(' + fin + ')' }
      ], { duration: dur, easing: dy > 0 ? 'cubic-bezier(.5, -.45, .8, .6)' : 'cubic-bezier(.25, .6, .35, 1)', fill: 'forwards' });
      volando++;
      var hecho = false;
      var aterriza = function(){
        if (hecho) return; hecho = true;
        if (el.parentNode) el.parentNode.removeChild(el);
        volando = Math.max(0, volando - 1);
        h.classList.remove('is-espera');
        if (h.classList.contains('is-f')) reanima(h, 'is-nuevo');
        if (!volando && pendienteFiesta){ pendienteFiesta = false; fiesta(); }
      };
      y.onfinish = aterriza; y.oncancel = aterriza;
      setTimeout(aterriza, dur + 400);   /* red por si el navegador no avisa */
    }

    /* Al completar el pack: los huecos hacen la ola y el boton se enciende con un destello. */
    var pendienteFiesta = false;
    var finFiesta = null;
    function fiesta(){
      if (volando){ pendienteFiesta = true; return; }
      reanima(barra, 'is-listo'); clearTimeout(finFiesta);
      finFiesta = setTimeout(function(){ if (barra) barra.classList.remove('is-listo'); }, 1400);
    }

    /* ---------- las acciones ---------- */
    function cambiaPack(p){
      if (p === st.pack) return;
      calla();
      /* Cada tamaño recuerda lo suyo: ir a tres y volver no pierde las seis. Tres llega con el trio mas pedido
         (Jazmin, Noble y Pomelo: un 33 % de los packs de 3 en ago-sep 2026), listo para pagar o cambiar. */
      st.mem[st.pack] = st.sel.slice();
      st.pack = p;
      deLaTienda = false;
      if (st.mem[p]) st.sel = st.mem[p].slice();
      else if (p === 6) st.sel = seis.slice();
      else { st.sel = trio.slice(); deLaTienda = true; }
      render();
      var n = q('.jes__pack[aria-checked="true"] .jes__pack-n'); if (n && !quieto()) reanima(n, 'is-pop');
    }
    function suma(i){
      calla();
      var k = st.sel.length;
      /* Con el trio de serie sin tocar, una cuarta no sube a seis: entra en lugar de la tercera. Se dice y se deshace. */
      if (deLaTienda && st.pack === 3 && k >= 3 && st.sel.indexOf(i) === -1){
        var fuera = st.sel[2], vu = puedeVolar(i, 2);
        deLaTienda = false;
        if (vu) vuela(i, 2);
        st.sel[2] = i; render(vu ? 2 : -1);
        avisa(T('tcambia', '{n} entra en lugar de {m}', nombre(i)).split('{m}').join(nombre(fuera)), function(){ st.sel[2] = fuera; deLaTienda = true; });
        return true;
      }
      deLaTienda = false;
      if (k < st.pack){
        var vuelo = puedeVolar(i, k);
        if (vuelo) vuela(i, k);   /* antes de pintar: asi la fiesta de pack completo espera a que aterrice */
        st.sel.push(i); render(vuelo ? k : -1);
        return true;
      }
      /* Con tres puestas, una cuarta pasa a seis: cada toque suma. Se dice y se puede deshacer. */
      if (st.pack === 3){
        st.mem[3] = st.sel.slice();
        st.pack = 6; st.sel.push(i); render();
        var n = q('.jes__pack[aria-checked="true"] .jes__pack-n'); if (n && !quieto()) reanima(n, 'is-pop');
        avisa(T('tsube6', 'Pasas al pack de 6 · {n}', precioDe(6, st.mode).trim()), function(){ st.sel.pop(); st.pack = 3; st.mem[3] = null; });
        return true;
      }
      avisa(T('tlleno6', 'Tu pack de 6 está completo. Quita una con el −.'));
      var c = cards[i] && cards[i].querySelector('.jes__ctl'); if (c) reanima(c, 'is-no');
      return false;
    }
    function resta(i){
      var pos = st.sel.lastIndexOf(i);
      if (pos < 0) return;
      calla(); deLaTienda = false; st.sel.splice(pos, 1); render();
    }

    /* ---------- pintar ---------- */
    function pintaPacks(){
      if (carril) carril.setAttribute('data-sel', String(st.pack));
      sec.querySelectorAll('[data-jes-pack]').forEach(function(b){
        b.setAttribute('aria-checked', parseInt(b.getAttribute('data-jes-pack'), 10) === st.pack ? 'true' : 'false');
      });
      sec.querySelectorAll('[data-jes-packprice]').forEach(function(e){
        pon(e, precioDe(parseInt(e.getAttribute('data-jes-packprice'), 10), st.mode).trim());
      });
      /* El seis lleva su precio por esencia: es verdad y es su mejor argumento. */
      var tag = q('[data-jes-packtag]');
      if (tag){ var p6 = precioDe(6, st.mode), u = num(p6) / 6; tag.hidden = !u; if (u) pon(tag, T('tcadauna', '{n} cada una', fmt(Math.floor(u * 100) / 100, p6))); }
      pon(q('[data-jes-sub]'), st.mode === 'sub' ? T('tsublinea', 'Cada 3 meses · envío gratis · sin permanencia') : T('toncelinea', 'Un solo pago · envío gratis'));
    }
    function pintaCartas(){
      if (grid) grid.classList.toggle('is-lleno', falta() <= 0 && st.pack === 6);
      picks.forEach(function(b, i){
        var n = veces(i), c = cards[i];
        if (c) c.classList.toggle('is-on', n > 0);
        b.setAttribute('aria-pressed', n > 0 ? 'true' : 'false');
        b.setAttribute('aria-label', n === 0 ? T('tariaanadir', 'Añadir {n} a tu pack', nombre(i)) : T('tariapuestas', '{n} en tu pack', nombre(i) + ' ×' + n));
        var m = c && c.querySelector('[data-jes-menos]');
        if (m){ m.tabIndex = n > 0 ? 0 : -1; m.setAttribute('aria-hidden', n > 0 ? 'false' : 'true'); }
        if (n > 0) rueda(c && c.querySelector('[data-jes-num]'), n);
      });
    }
    function pintaBarra(esperando){
      huecos.forEach(function(h, k){
        var dentro = k < st.pack, i = dentro ? st.sel[k] : null, lleno = i != null;
        h.classList.toggle('is-fuera', !dentro);
        var foto = lleno ? (picks[i].getAttribute('data-foto') || '') : '';
        if (lleno && h.getAttribute('data-foto') !== foto){
          h.setAttribute('data-foto', foto);
          h.style.setProperty('--foto', 'url("' + foto + '")');
          h.style.setProperty('--tinte', picks[i].getAttribute('data-tinte') || '');
          if (k === esperando) h.classList.add('is-espera');
          else if (arrancado && !quieto() && h.classList.contains('is-f')) reanima(h, 'is-nuevo');
        }
        if (!lleno) h.removeAttribute('data-foto');
        if (lleno && !h.classList.contains('is-f') && k !== esperando && arrancado && !quieto()) reanima(h, 'is-nuevo');
        h.classList.toggle('is-f', lleno);
      });
      pon(q('[data-jes-precio]'), conExtra(precio()));
      /* Con botella extra en suscripcion, el precio es el de hoy y «despues X cada 3 meses» va en su linea. */
      var conX = st.mode === 'sub' && st.extra > 0, hoy = q('[data-jes-hoy]');
      pon(q('[data-jes-periodo]'), conX ? T('thoy', 'Hoy pagas {n}', '').replace(/\s+/g, ' ').trim()
        : (st.mode === 'sub' ? T('tpersub', 'cada 3 meses') : T('tperonce', 'un solo pago')));
      if (hoy){ hoy.hidden = !conX; if (conX){ var dp = T('tdespues', 'después {n} cada 3 meses', precio().trim()); hoy.textContent = dp.charAt(0).toUpperCase() + dp.slice(1); } }
      var cta = q('[data-jes-cta]'), f = falta();
      if (cta){
        cta.setAttribute('aria-disabled', f > 0 ? 'true' : 'false');
        var lab = cta.querySelector('[data-jes-cta-label]');
        if (lab && !cta.disabled) pon(lab, f > 0 ? T('teligemas', 'Elige {n} más', f) : T('tcta', 'Ir al pago'));
      }
      var sw = q('[data-jes-switch]');
      if (sw) sw.setAttribute('aria-checked', st.mode === 'once' ? 'true' : 'false');
      pon(q('[data-jes-extra-num]'), String(st.extra));
      /* Las botellas extra se ven en el pedido: +n sobre la botella de regalo. */
      var bn = q('[data-jes-botn]');
      if (bn){ var tx = st.extra > 0 ? '+' + st.extra : ''; if (bn.textContent !== tx){ bn.textContent = tx; bn.hidden = !st.extra; if (st.extra && arrancado && !quieto()) reanima(bn, 'is-nuevo'); } }
      var xm = q('[data-jes-extra-menos]'), xp = q('[data-jes-extra-mas]');
      if (xm) xm.setAttribute('aria-disabled', st.extra <= 0 ? 'true' : 'false');
      if (xp) xp.setAttribute('aria-disabled', st.extra >= 5 ? 'true' : 'false');
    }

    /* El pack se guarda para el configurador y la ficha, y se anuncia al recibo de la portada (jaspe-ticket). */
    function cede(){
      try{
        window.JaspePack = { pack: st.pack, mode: st.mode, extra: st.extra || 0, precio: precio(), sel: st.sel.map(function(i){ return picks[i] && picks[i].getAttribute('data-jes-ess'); }) };
        document.dispatchEvent(new CustomEvent('jaspe:pack', { detail: window.JaspePack }));
      }catch(e){}
      if (!arrancado) return;   /* lo de serie no es un pedido: no se guarda */
      try{
        var obj = {};
        st.sel.forEach(function(i){ var v = picks[i] && picks[i].getAttribute('data-jes-ess'); if (v) obj[v] = (obj[v] || 0) + 1; });
        if (!st.sel.length){ localStorage.removeItem('jaspe:pack'); return; }
        localStorage.setItem('jaspe:pack', JSON.stringify({ picks: obj, mode: st.mode, extra: st.extra || 0, ts: Date.now() }));
      }catch(e){}
    }
    /* Quien monto su pack (aqui o desde la ficha de una esencia) y vuelve, lo encuentra como lo dejo. 24 h. */
    function rescata(){
      try{
        var g = JSON.parse(localStorage.getItem('jaspe:pack') || 'null');
        if (!g || !g.picks) return;
        if (!g.ts || (Date.now() - g.ts) > 86400000){ localStorage.removeItem('jaspe:pack'); return; }
        var porVar = {};
        picks.forEach(function(b, i){ var v = b.getAttribute('data-jes-ess'); if (v) porVar[v] = i; });
        var sel = [];
        for (var k in g.picks){
          if (!Object.prototype.hasOwnProperty.call(g.picks, k) || porVar[k] == null) continue;
          for (var j = 0, n = parseInt(g.picks[k], 10) || 0; j < n && sel.length < 6; j++) sel.push(porVar[k]);
        }
        if (!sel.length) return;
        st.pack = sel.length <= 3 ? 3 : 6;
        st.sel = sel;
        if (g.mode === 'sub' || g.mode === 'once') st.mode = g.mode;
      }catch(e){}
    }

    var completoAntes = null;
    function render(esperando){
      pintaPacks(); pintaCartas(); pintaBarra(esperando); cede();
      if (modal && modal.open) pintaMadd();
      var completo = falta() <= 0;
      if (arrancado && completo && completoAntes === false && !quieto()) fiesta();
      completoAntes = completo;
      if (!arrancado){
        arrancado = true;
        /* Las transiciones se encienden despues del primer pintado: un pack rescatado no se anima al cargar. */
        requestAnimationFrame(function(){ requestAnimationFrame(function(){ sec.classList.add('is-vivo'); }); });
      }
    }

    /* ---------- la ficha de cada esencia ----------
       Una vista por esencia en un carrusel nativo (scroll-snap): el dedo la pasa con su inercia de verdad. */
    var modal = q('[data-jes-modal]'), pista = q('[data-jes-mpista]'), mIdx = -1;
    var madd = q('[data-jes-madd]'), mnota = q('[data-jes-mnota]'), mctl = q('[data-jes-mctl]'), mnum = q('[data-jes-mnum]');
    var mmas = q('[data-jes-mmas]'), mmenos = q('[data-jes-mmenos]'), mseg = q('[data-jes-mseg]');
    var mprev = q('[data-jes-mprev]'), mnext = q('[data-jes-mnext]');
    var pintaMadd = function(){}, mAviso = null;
    if (modal && modal.showModal && pista){
      var orden = [], vistas = {};
      var monta = function(){
        if (orden.length) return;
        picks.forEach(function(b, i){
          var tpl = sec.querySelector('[data-jes-ficha="' + i + '"]'); if (!tpl) return;
          pista.appendChild(tpl.content.cloneNode(true));
          var v = pista.lastElementChild; vistas[i] = v; orden.push(i);
          var f = v.querySelector('.jes__mfoto'); if (f && cards[i]) f.style.backgroundImage = getComputedStyle(cards[i]).getPropertyValue('--ess-full-lg');
          if (mseg) mseg.appendChild(document.createElement('i'));
        });
      };
      pintaMadd = function(){
        if (!madd || mIdx < 0) return;
        var n = veces(mIdx), lleno = falta() <= 0;
        if (mctl){ mctl.hidden = n === 0; madd.hidden = n > 0; }
        if (n > 0 && mnum){
          pon(mnum, T('tmnota', '{n} en tu pack', n));
          if (mmas) mmas.setAttribute('aria-disabled', lleno && st.pack === 6 ? 'true' : 'false');
        } else {
          /* Con el trio de serie sin tocar, anadir no sube a seis: cambia la tercera (lo dice el aviso). */
          var est = !lleno || (deLaTienda && st.pack === 3) ? 'anadir' : (st.pack === 3 ? 'sube' : 'lleno');
          madd.dataset.est = est;
          madd.textContent = est === 'sube' ? T('tmsube', 'Añadir y pasar al pack de 6') : est === 'lleno' ? T('tmlleno', 'Tu pack de 6 está completo') : T('tmanadir', 'Añadir a mi pack');
          madd.disabled = est === 'lleno';
        }
        if (mnota && !mAviso){
          mnota.classList.remove('is-aviso');
          var f = falta();
          mnota.textContent = T('tmpack', 'Tu pack: {n}', st.sel.length + ' de ' + st.pack) + (f > 0 ? ' · ' + T('teligemas', 'Elige {n} más', f).toLowerCase() : ' ✓');
        }
        var pr = q('[data-jes-mprog]'); if (pr) pr.style.width = Math.min(100, st.sel.length / st.pack * 100) + '%';
      };
      var activa = function(i){
        if (i === mIdx || !vistas[i]) return;
        mIdx = i;
        var k = orden.indexOf(i);
        orden.forEach(function(x, j){ vistas[x].classList.toggle('is-activa', x === i); if (mseg && mseg.children[j]) mseg.children[j].classList.toggle('is-on', j <= k); });
        var h = vistas[i].querySelector('.jes__mnom'); if (h) modal.setAttribute('aria-labelledby', h.id);
        if (mprev) mprev.disabled = k <= 0;
        if (mnext) mnext.disabled = k >= orden.length - 1;
        mAviso = null; pintaMadd();
      };
      var ve = function(k, suave){
        k = Math.max(0, Math.min(orden.length - 1, k));
        pista.scrollTo({ left: k * pista.clientWidth, behavior: suave && !quieto() ? 'smooth' : 'auto' });
        activa(orden[k]);
      };
      var abre = function(i){
        monta(); if (!vistas[i]) return;
        if (!modal.open){ modal.classList.remove('is-cierra'); modal.style.transform = ''; modal.showModal(); }
        mIdx = -1;
        var prev = pista.style.scrollBehavior; pista.style.scrollBehavior = 'auto';
        ve(orden.indexOf(i), false);
        pista.style.scrollBehavior = prev;
        var h = vistas[i].querySelector('.jes__mnom'); if (h){ h.tabIndex = -1; try { h.focus({ preventScroll: true }); } catch(e){} }
      };
      var mueve = function(d){ if (mIdx >= 0) ve(orden.indexOf(mIdx) + d, true); };
      /* El dedo manda: al soltar, la vista que queda centrada es la activa. */
      var rq = null;
      pista.addEventListener('scroll', function(){
        if (rq) return;
        rq = requestAnimationFrame(function(){ rq = null; var w = pista.clientWidth || 1; activa(orden[Math.round(pista.scrollLeft / w)]); });
      }, { passive: true });
      /* Cerrar tambien se anima: la vista baja (o se desvanece en escritorio) y luego se cierra. */
      var cerrando = false;
      var cierra = function(desde){
        if (!modal.open || cerrando) return;
        if (quieto() || !modal.animate){ modal.close(); return; }
        cerrando = true; modal.classList.add('is-cierra');
        var movil = !window.matchMedia('(min-width: 860px)').matches;
        var an = modal.animate(movil ? [{ transform: 'translateY(' + (desde || 0) + 'px)' }, { transform: 'translateY(100%)' }] : [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(12px) scale(.98)' }], { duration: movil ? 280 : 200, easing: 'cubic-bezier(.4, 0, 1, 1)', fill: 'forwards' });
        an.onfinish = function(){ modal.close(); an.cancel(); modal.style.transform = ''; modal.classList.remove('is-cierra'); cerrando = false; };
      };
      modal.addEventListener('cancel', function(ev){ ev.preventDefault(); cierra(); });
      modal.addEventListener('close', function(){ mIdx = -1; mAviso = null; });
      modal.addEventListener('click', function(ev){ if (ev.target === modal) cierra(); });
      modal.addEventListener('keydown', function(ev){ if (ev.key === 'ArrowLeft') mueve(-1); else if (ev.key === 'ArrowRight') mueve(1); });
      /* Arrastrar hacia abajo desde arriba del todo cierra; la vista sigue al dedo. */
      var t0 = null;
      pista.addEventListener('touchstart', function(ev){
        var t = ev.touches[0], v = mIdx >= 0 ? vistas[mIdx] : null;
        t0 = { x: t.clientX, y: t.clientY, arriba: !v || v.scrollTop <= 0, baja: false };
      }, { passive: true });
      pista.addEventListener('touchmove', function(ev){
        if (!t0) return;
        var t = ev.touches[0], dx = t.clientX - t0.x, dy = t.clientY - t0.y;
        if (t0.arriba && (t0.baja || (dy > 10 && dy > Math.abs(dx) * 1.4)) && !window.matchMedia('(min-width: 860px)').matches){ t0.baja = true; modal.style.transform = 'translateY(' + Math.max(0, dy) + 'px)'; }
      }, { passive: true });
      pista.addEventListener('touchend', function(ev){
        if (!t0) return;
        var ini = t0, dy = ev.changedTouches[0].clientY - ini.y; t0 = null;
        if (!ini.baja) return;
        if (dy > 120) cierra(dy);
        else { if (modal.animate) modal.animate([{ transform: 'translateY(' + Math.max(0, dy) + 'px)' }, { transform: 'none' }], { duration: 240, easing: 'cubic-bezier(.23, 1, .32, 1)' }); modal.style.transform = ''; }
      }, { passive: true });
      pista.addEventListener('touchcancel', function(){ if (t0 && t0.baja) modal.style.transform = ''; t0 = null; }, { passive: true });
      sec.querySelectorAll('[data-jes-info]').forEach(function(bt){
        bt.addEventListener('click', function(){ abre(parseInt(bt.getAttribute('data-jes-info'), 10)); });
      });
      var bc = q('[data-jes-cerrar]'); if (bc) bc.addEventListener('click', function(){ cierra(); });
      if (mprev) mprev.addEventListener('click', function(){ mueve(-1); });
      if (mnext) mnext.addEventListener('click', function(){ mueve(1); });
      if (madd) madd.addEventListener('click', function(){ if (!madd.disabled && mIdx >= 0) suma(mIdx); });
      if (mmas) mmas.addEventListener('click', function(){ if (mIdx >= 0) suma(mIdx); });
      if (mmenos) mmenos.addEventListener('click', function(){ if (mIdx >= 0) resta(mIdx); });
    } else { sec.querySelectorAll('[data-jes-info]').forEach(function(bt){ bt.removeAttribute('aria-haspopup'); bt.disabled = true; }); }

    /* ---------- escuchas ---------- */
    sec.querySelectorAll('[data-jes-pack]').forEach(function(b){
      b.addEventListener('click', function(){ cambiaPack(parseInt(b.getAttribute('data-jes-pack'), 10)); });
    });
    picks.forEach(function(b, i){
      b.addEventListener('click', function(){ suma(i); });
      var menos = cards[i] && cards[i].querySelector('[data-jes-menos]');
      if (menos) menos.addEventListener('click', function(){ resta(i); });
    });
    var sw = q('[data-jes-switch]');
    if (sw) sw.addEventListener('click', function(){ calla(); st.mode = st.mode === 'sub' ? 'once' : 'sub'; render(); });
    var xmas = q('[data-jes-extra-mas]'), xmenos = q('[data-jes-extra-menos]');
    if (xmas) xmas.addEventListener('click', function(){ if (st.extra < 5){ st.extra++; render(); } });
    if (xmenos) xmenos.addEventListener('click', function(){ if (st.extra > 0){ st.extra--; render(); } });

    /* ---------- pago ---------- No navega: lo hace el motor (jaspe-configurador-motor). */
    var cta = q('[data-jes-cta]');
    if (cta) cta.addEventListener('click', function(){
      if (cta.disabled) return;
      var f = falta();
      if (f > 0){
        /* El boton no se apaga: explica que falta y lleva a la primera que se puede añadir. */
        avisa(T('teligemas', 'Elige {n} más', f)); reanima(cta, 'is-no');
        var libre = cards.filter(function(c){ return c && !c.classList.contains('is-on'); })[0];
        if (libre) libre.scrollIntoView({ behavior: quieto() ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      var pk = {}, total = 0;
      st.sel.forEach(function(i){ var v = picks[i].getAttribute('data-jes-ess'); if (v){ pk[v] = (pk[v] || 0) + 1; total++; } });
      if (total !== st.pack) return;           /* falta alguna variante: no enviar */
      var ex = q('[data-jes-extra]');
      document.dispatchEvent(new CustomEvent('jaspe:configurador:submit', {
        detail: { pack: st.pack, mode: st.mode, picks: pk, extra: ex ? st.extra : 0, addonVariant: ex ? ex.getAttribute('data-variante') : '' }
      }));
    });
    /* El error dice QUE ha pasado. */
    document.addEventListener('jaspe:configurador:fail', function(ev){
      var motivo = (ev && ev.detail && ev.detail.motivo) || 'red';
      var e = q('[data-jes-err]');
      if (e){
        e.textContent = motivo === 'agotado'
          ? T('err_agotado', 'Se ha agotado una de las esencias. Cámbiala por otra y sigue: no se ha cobrado nada.')
          : T('err_red', 'No hemos podido preparar tu pago. No se ha cobrado nada, vuelve a intentarlo.');
        e.hidden = false;
      }
      if (cta) cta.disabled = false;
      render();
    });
    /* Al volver atras desde el checkout: fuera el error y el boton otra vez vivo. */
    document.addEventListener('jaspe:configurador:vuelve', function(){
      var e = q('[data-jes-err]'); if (e) e.hidden = true;
      if (cta) cta.disabled = false;
      render();
    });

    /* ---------- entrada ---------- Solo si la seccion aun no esta a la vista. Si el JS falla, todo se ve. */
    (function(){
      if (quieto() || !('IntersectionObserver' in window)) return;
      var alto = window.innerHeight || 800;
      function prepara(el, raiz){
        if (!el || el.getBoundingClientRect().top < alto * .9) return;
        (raiz || el).classList.add('jes-arma');
        var hecho = false, responde = false;
        var suelta = function(){ if (hecho) return; hecho = true; (raiz || el).classList.remove('jes-arma'); (raiz || el).classList.add('jes-visto'); };
        var io = new IntersectionObserver(function(es){ responde = true; if (es.some(function(x){ return x.isIntersecting; })){ suelta(); io.disconnect(); } }, { threshold: .15 });
        io.observe(el);
        setTimeout(function(){ if (!responde) suelta(); }, 2600);   /* solo si el observador no contesta nunca */
      }
      prepara(q('.jes__title'), sec);
      prepara(grid);
    })();

    rescata();
    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-jfaq]').forEach(function (root) {
    root.classList.add('jfaq--js'); // activa el modo animado (oculto sin JS)

    // Reveal
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.12 });
      io.observe(root);
    } else { root.classList.add('is-in'); }

    var items = [].slice.call(root.querySelectorAll('[data-jfaq-item]'));

    function openItem(item, doScroll) {
      items.forEach(function (o) {
        if (o !== item) { o.classList.remove('is-open'); var b = o.querySelector('[data-jfaq-btn]'); if (b) b.setAttribute('aria-expanded', 'false'); }
      });
      item.classList.add('is-open');
      var btn = item.querySelector('[data-jfaq-btn]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      if (doScroll) {
        setTimeout(function () {
          var rect = item.getBoundingClientRect();
          window.scrollTo({ top: window.pageYOffset + rect.top - 90, behavior: 'smooth' });
        }, 60);
      }
    }

    items.forEach(function (item) {
      var btn = item.querySelector('[data-jfaq-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        if (willOpen) { openItem(item, false); }
        else { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      });
    });

    // Apertura por hash (#faq-mascotas, etc.)
    function openByHash() {
      var hash = window.location.hash;
      if (!hash || hash.length < 2) return;
      var target = null;
      try { target = root.querySelector(hash); } catch (e) { return; }
      if (!target) return;
      if (!target.classList.contains('jfaq__item')) { target = target.closest('.jfaq__item'); }
      if (!target) return;
      openItem(target, true);
    }
    openByHash();
    window.addEventListener('hashchange', openByHash);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-ficha-esencia"]) return;
  try {
    
(function(){
  /* «Crear mi pack con…»: deja la esencia marcada donde el configurador de la portada la busca
     (la misma llave y forma que escribe él) y va a él. Sin JS, el enlace lleva igual, sin marcar. */
  document.querySelectorAll('[data-jfe-cta]').forEach(function(a){
    a.addEventListener('click', function(){
      try {
        var picks = {}; picks[a.getAttribute('data-variante')] = 1;
        localStorage.setItem('jaspe:pack', JSON.stringify({ picks: picks, mode: 'sub', extra: 0, ts: Date.now() }));
      } catch(e){}
    });
  });
  /* El fijo sale cuando el botón de arriba ha pasado hacia arriba, y se retira al llegar al pie. */
  var fijo = document.querySelector('[data-jfe-fijo]'), arriba = document.querySelector('.jfe__intro .jfe__cta'), pie = document.querySelector('footer, .jftr');
  if (fijo && arriba && 'IntersectionObserver' in window){
    var pasado = false, enPie = false;
    function pinta(){ fijo.hidden = !(pasado && !enPie); }
    new IntersectionObserver(function(es){ var e = es[0]; pasado = !e.isIntersecting && e.boundingClientRect.top < 0; pinta(); }).observe(arriba);
    if (pie) new IntersectionObserver(function(es){ enPie = es[0].isIntersecting; pinta(); }).observe(pie);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var f = document.querySelector('[data-jftr]');
  if (f) {
    if ('IntersectionObserver' in window) {
      f.classList.add('jftr--js');
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { f.classList.add('is-in'); io.disconnect(); } }); }, { threshold: 0.12 });
      io.observe(f);
    } else { f.classList.add('is-in'); }
    /* Acordeon de las columnas, solo en movil. Fuera de movil se deshace: enlaces visibles y
       el titulo vuelve a ser un titulo, sin rol de boton. */
    var mqCol = window.matchMedia('(max-width: 859px)');
    var cols = f.querySelectorAll('[data-jftr-col]');
    var modoCols = function () {
      var on = mqCol.matches;
      f.classList.toggle('jftr--acordeon', on);
      Array.prototype.forEach.call(cols, function (c) {
        var t = c.querySelector('[data-jftr-toggle]'), l = c.querySelector('.jftr__links');
        if (!t || !l) return;
        if (on) { t.setAttribute('role', 'button'); t.setAttribute('tabindex', '0'); t.setAttribute('aria-expanded', 'false'); t.setAttribute('aria-controls', l.id); l.hidden = true; }
        else { t.removeAttribute('role'); t.removeAttribute('tabindex'); t.removeAttribute('aria-expanded'); t.removeAttribute('aria-controls'); l.hidden = false; }
      });
    };
    var abreCol = function (t) {
      if (!f.classList.contains('jftr--acordeon')) return;
      var l = document.getElementById(t.getAttribute('aria-controls'));
      var abierto = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      if (l) l.hidden = abierto;
    };
    Array.prototype.forEach.call(cols, function (c) {
      var t = c.querySelector('[data-jftr-toggle]');
      if (!t) return;
      t.addEventListener('click', function () { abreCol(t); });
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abreCol(t); } });
    });
    modoCols();
    if (mqCol.addEventListener) mqCol.addEventListener('change', modoCols); else mqCol.addListener(modoCols);
  }
  // Sticky: añade un spacer una sola vez para no tapar el final del footer en móvil
  var sticky = document.querySelector('[data-jftr-sticky]');
  if (!sticky) return; // sticky desactivado (show_sticky:false) -> no montar spacer ni el IO de supresores
  if (!document.querySelector('[data-jftr-spacer]')) {
    var sp = document.createElement('div');
    sp.setAttribute('data-jftr-spacer', '');
    sp.setAttribute('aria-hidden', 'true');
    sp.style.height = '76px';
    sp.style.background = 'var(--c-granate)';
    var mq = window.matchMedia('(max-width: 859px)');
    var apply = function () { sp.style.display = mq.matches ? 'block' : 'none'; };
    apply(); mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
    if (f && f.parentNode) f.parentNode.insertBefore(sp, f.nextSibling);
  }
  // Afinado del sticky (Enrique 22/06): aparece SOLO tras pasar el hero y se esconde cuando
  // ya hay un CTA de compra en pantalla. Supresores = el hero (#top) + todo enlace al
  // configurador (mismo destino que el sticky o cualquier ruta con "configura"): los
  // "Crea tu pack" del hero, bandas y footer. El sticky se ve únicamente cuando NINGÚN
  // supresor está a la vista. Conserva el empuje a compra en la "zona muerta" del medio,
  // sin competir con los CTA ni asomar desde el inicio.
  if ('IntersectionObserver' in window) {
    var link = sticky.querySelector('a');
    var target = '';
    try { target = new URL(link.getAttribute('href'), location.href).pathname.toLowerCase(); } catch (e) {}
    var suppressors = [];
    var hero = document.getElementById('top');
    if (hero) suppressors.push(hero);
    Array.prototype.forEach.call(document.querySelectorAll('a[href]'), function (a) {
      if (sticky.contains(a)) return;
      var p; try { p = new URL(a.getAttribute('href'), location.href).pathname.toLowerCase(); } catch (e) { return; }
      if ((target && p === target) || p.indexOf('configura') !== -1) suppressors.push(a);
    });
    if (suppressors.length) {
      sticky.classList.add('is-hidden');
      var visible = new Set();
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
        var any = visible.size > 0;
        sticky.classList.toggle('is-hidden', any);
        sticky.setAttribute('aria-hidden', any ? 'true' : 'false');
      }, { threshold: 0 });
      suppressors.forEach(function (el) { sio.observe(el); });
    }
  }
})();

  /* Botellas sueltas: el enlace del footer (con data-jaspe-buy-bottle) abre un modal con selector
     de cantidad. El modal: vacía carrito + añade N (pago único) → /checkout. Sin modal → fallback a la ficha.
     La compra en sí es window.JaspeComprarBotellas(n, variante): la usan el modal y la ficha de la
     botella (jaspe-ficha-botella), para que no haya dos maneras de cobrar lo mismo. Shopify frena
     /cart/*.js con un 429 en HTML: se reintenta UNA vez (en bucle agrava el bloqueo). */
  (function () {
    function pide(url, body) {
      var op = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body ? JSON.stringify(body) : undefined };
      return fetch(url, op).then(function (r) {
        if (r.status !== 429) return r;
        return new Promise(function (ok) { setTimeout(ok, 900); }).then(function () { return fetch(url, op); });
      });
    }
    window.JaspeComprarBotellas = function (n, variante) {
      var id = parseInt(variante, 10) || 0;
      if (!id) { var m = document.querySelector('[data-jbm]'); id = m ? parseInt(m.dataset.variant, 10) || 0 : 0; }
      if (!id) return Promise.reject(new Error('sin variante'));
      return pide('/cart/clear.js')
        .then(function (r) { if (!r.ok) throw new Error('clear ' + r.status); return pide('/cart/add.js', { items: [{ id: id, quantity: n, properties: { _jaspeBottleSolo: '1' } }] }); })
        .then(function (r) { if (!r.ok) return r.text().then(function (x) { throw new Error('add ' + r.status + ' ' + x.slice(0, 120)); }); window.location.href = '/checkout'; });
    };
  })();
  (function () {
    var modal = document.querySelector('[data-jbm]');
    if (!modal) {
      document.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('[data-jaspe-buy-bottle]') : null;
        if (!b) return; e.preventDefault();
        var h = b.getAttribute('href'); if (h) window.location.href = h;
      });
      return;
    }
    var variant = parseInt(modal.dataset.variant, 10) || 0;
    var qty = 1;
    var offers = modal.querySelectorAll('[data-jbm-offer]');
    var qtyEl = modal.querySelector('[data-jbm-qty]');
    var totalEl = modal.querySelector('[data-jbm-total]');
    var errEl = modal.querySelector('[data-jbm-err]');
    var confirmBtn = modal.querySelector('[data-jbm-confirm]');
    function render() { if (qtyEl) qtyEl.textContent = qty; if (totalEl) totalEl.textContent = qty === 1 ? modal.dataset.tBuyOne : (modal.dataset.tBuyMany || '').replace('{n}', qty); Array.prototype.forEach.call(offers, function (o) { var on = (parseInt(o.getAttribute('data-jbm-offer'), 10) || 0) === qty; o.classList.toggle('is-selected', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }
    function closeModal() { try { modal.close(); } catch (e) { modal.removeAttribute('open'); } }
    var inc = modal.querySelector('[data-jbm-inc]'), dec = modal.querySelector('[data-jbm-dec]');
    if (inc) inc.addEventListener('click', function () { if (qty < 20) { qty++; render(); } });
    if (dec) dec.addEventListener('click', function () { if (qty > 1) { qty--; render(); } });
    Array.prototype.forEach.call(offers, function (o) { o.addEventListener('click', function () { qty = parseInt(o.getAttribute('data-jbm-offer'), 10) || 1; render(); }); });
    modal.querySelectorAll('[data-jbm-close]').forEach(function (x) { x.addEventListener('click', closeModal); });
    if (confirmBtn) confirmBtn.addEventListener('click', function () {
      if (confirmBtn.dataset.loading === '1') return;
      confirmBtn.dataset.loading = '1';
      var prev = totalEl ? totalEl.textContent : '';
      if (totalEl) totalEl.textContent = modal.dataset.tProcessing;
      if (errEl) errEl.hidden = true;
      window.JaspeComprarBotellas(qty, variant)
        .catch(function (err) { console.error('JASPE bottle:', err); confirmBtn.dataset.loading = ''; if (totalEl) totalEl.textContent = prev; if (errEl) { errEl.textContent = modal.dataset.tError; errEl.hidden = false; } });
    });
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-jaspe-buy-bottle]') : null;
      if (!b) return;
      e.preventDefault();
      qty = 1; render();
      if (modal.showModal) modal.showModal(); else modal.setAttribute('open', '');
    });
    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-gracias-qr"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.jgq').forEach(function (root) {
      root.querySelectorAll('[data-jgq-faq-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-jgq-faq]');
          if (!item) return;
          var open = item.classList.toggle('jgq__faq-item--open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  })();

  /* Aparicion suave al entrar en pantalla. Blindado: el estado oculto solo existe si
     este JS marca la seccion, y una red de seguridad revela todo pase lo que pase. */
  (function () {
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (rm || !('IntersectionObserver' in window)) return; /* sin animacion: todo visible por defecto */

    document.querySelectorAll('.jgq').forEach(function (root) {
      var els = root.querySelectorAll('[data-jgq-reveal]');
      if (!els.length) return;
      root.classList.add('jgq--reveal'); /* activa el estado oculto SOLO ahora */

      var reveal = function (el) { el.classList.add('is-in'); };
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });
      els.forEach(function (el) { io.observe(el); });

      /* Red de seguridad: si el observer no dispara (pestana en 2o plano, navegador raro),
         a los 1,5 s se muestra todo. Mas vale sin animacion que invisible. */
      setTimeout(function () { els.forEach(reveal); }, 1500);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-hablemos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jhab]');
  if (!els.length) return;

  // Toggle "Ver más / Ver menos"
  document.querySelectorAll('[data-jhab-toggle]').forEach(function (btn) {
    var card = btn.closest('.jhab__card');
    var panel = card ? card.querySelector('[data-jhab-more]') : null;
    if (!card || !panel) return;
    panel.removeAttribute('hidden');
    btn.addEventListener('click', function () {
      var willOpen = !card.classList.contains('is-open');
      card.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      var open = btn.getAttribute('data-label-open') || 'Ver menos';
      var closed = btn.getAttribute('data-label-closed') || 'Ver más';
      var ico = btn.querySelector('.jhab__link-ico');
      btn.textContent = (willOpen ? open : closed) + ' ';
      if (ico) btn.appendChild(ico);
    });
  });

  // Reveal
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.15 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-header-v3"] && !Shopify.designMode) return;
  try {
    
// Condensa el header al hacer scroll (sin scroll-timeline para soporte amplio).
(function () {
  var bars = document.querySelectorAll('[data-jhdr]');
  if (!bars.length) return;
  var onScroll = function () {
    var c = window.scrollY > 40;
    bars.forEach(function (b) { b.classList.toggle('is-condensed', c); });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// Se esconde al bajar y vuelve al subir. Arriba del todo, con el menu abierto o con el foco dentro, siempre visible.
(function () {
  var h = document.querySelector('[data-jhdr]');
  if (!h) return;
  var y0 = window.scrollY, acc = 0, rq = false;
  function tick() {
    rq = false;
    var y = Math.max(0, window.scrollY), d = y - y0; y0 = y;
    var foco = h.contains(document.activeElement) && document.activeElement !== document.body;
    if (y < 160 || h.classList.contains('is-open') || (foco && document.activeElement.matches(':focus-visible'))) { h.classList.remove('is-oculto'); acc = 0; return; }
    if ((d > 0) !== (acc > 0)) acc = 0;
    acc += d;
    if (acc > 24) h.classList.add('is-oculto');
    else if (acc < -16) h.classList.remove('is-oculto');
  }
  window.addEventListener('scroll', function () { if (!rq) { rq = true; requestAnimationFrame(tick); } }, { passive: true });
})();

// Contador de los botones de compra del header (barra y menu). Va a Clarity, que esta en toda la
// tienda, como evento hdr_cta con dos etiquetas: donde (portada u otra) y en que (barra o menu).
// Tambien al dataLayer y a los eventos de Shopify, por si un pixel lo quiere. Si algo falla, el boton sigue.
(function () {
  document.querySelectorAll('[data-jhdr] .jhdr__cta').forEach(function (a) {
    a.addEventListener('click', function () {
      try {
        var donde = document.getElementById('esencias') ? 'portada' : 'otra';
        var en = a.classList.contains('jhdr__cta--full') ? 'menu' : 'barra';
        var cl = window.clarity = window.clarity || function () { (cl.q = cl.q || []).push(arguments); };
        cl('set', 'hdr_cta_donde', donde); cl('set', 'hdr_cta_en', en); cl('event', 'hdr_cta');
        window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'jaspe_hdr_cta', donde: donde, en: en });
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('jaspe:hdr_cta', { donde: donde, en: en });
      } catch (e) {}
    });
  });
})();

// Cuantos encuentran la cuenta y la suscripcion: hdr_cuenta (icono de la barra, 09/10) y hdr_sub (tarjeta del menu,
// 08/10), en Clarity y en el dataLayer. Si algo falla, el enlace sigue.
(function () {
  document.querySelectorAll('[data-jhdr] [data-jhdr-sub], [data-jhdr] [data-jhdr-cuenta]').forEach(function (a) {
    a.addEventListener('click', function () {
      try {
        var cuenta = a.hasAttribute('data-jhdr-cuenta'), ev = cuenta ? 'hdr_cuenta' : 'hdr_sub';
        var en = a.getAttribute(cuenta ? 'data-jhdr-cuenta' : 'data-jhdr-sub');
        var cl = window.clarity = window.clarity || function () { (cl.q = cl.q || []).push(arguments); };
        cl('set', ev + '_en', en); cl('event', ev);
        window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'jaspe_' + ev, en: en });
      } catch (e) {}
    });
  });
})();

// Boton del header en la portada: lleva a las esencias (sin salir de la pagina) y se aparta
// mientras ya se ven la portada de arriba o las esencias. Sin JS, el enlace va al configurador.
(function () {
  var destino = document.getElementById('esencias');
  var h = document.querySelector('[data-jhdr]');
  if (!destino || !h) return;
  var cta = h.querySelector('.jhdr__bar .jhdr__cta');
  if (cta) cta.addEventListener('click', function (ev) {
    ev.preventDefault();
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Si la pagina sube, el header vuelve a aparecer y taparia el titular: se para debajo de el.
    var y = destino.getBoundingClientRect().top + window.scrollY;
    if (y < window.scrollY) y -= h.getBoundingClientRect().height;
    window.scrollTo({ top: Math.max(0, y), behavior: quieto ? 'auto' : 'smooth' });
  });
  if (!('IntersectionObserver' in window)) return;
  var vistos = new Set();
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) vistos.add(e.target); else vistos.delete(e.target); });
    h.classList.toggle('is-cta-fuera', vistos.size > 0);
  }, { threshold: 0 });
  [document.getElementById('top'), destino].filter(Boolean).forEach(function (el) { io.observe(el); });
})();

// Logo del header: oculto mientras el HERO (#top) está en pantalla; aparece
// suave al pasarlo (igual que en el diseño). Si no hay #top (páginas sin hero)
// o el tema lo desactiva, el logo se queda visible.
(function () {
  var hero = document.getElementById('top');
  // Con el fundido activo manda el fundido: ahi el logo TIENE que verse, en
  // marfil, sobre la foto. Este efecto lo esconderia.
  var logos = document.querySelectorAll('[data-jhdr][data-logo-reveal]:not([data-fundir]) .jhdr__logo');
  if (!logos.length || !hero || !('IntersectionObserver' in window)) return;
  logos.forEach(function (l) {
    l.style.transition = 'opacity .45s ease, transform .45s ease';
    l.style.opacity = '0'; l.style.transform = 'translateY(-4px)'; l.style.pointerEvents = 'none';
  });
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      var hidden = en.isIntersecting;
      logos.forEach(function (l) {
        l.style.opacity = hidden ? '0' : '1';
        l.style.transform = hidden ? 'translateY(-4px)' : 'none';
        l.style.pointerEvents = hidden ? 'none' : 'auto';
      });
    });
  }, { threshold: 0, rootMargin: '-65px 0px 0px 0px' });
  io.observe(hero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-mad-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-jmaq]').forEach(function (root) {
    root.classList.add('jmaq--js');
    var items = [].slice.call(root.querySelectorAll('[data-jmaq-item]'));
    function cierra(o) { o.classList.remove('is-open'); var b = o.querySelector('[data-jmaq-btn]'); if (b) b.setAttribute('aria-expanded', 'false'); }
    items.forEach(function (item) {
      var btn = item.querySelector('[data-jmaq-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var abrir = !item.classList.contains('is-open');
        items.forEach(function (o) { if (o !== item) cierra(o); });
        if (abrir) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
        else { cierra(item); }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-mad-intro"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jmi]');
  if (!els.length) return;
  function show(el) { el.classList.add('is-in'); }
  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(els, show);
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { show(en.target); io.unobserve(en.target); }
    });
  }, { threshold: 0.2 });
  Array.prototype.forEach.call(els, function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-modelo"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jmod]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.3 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-preparar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jprep]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.18 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-quees"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jquees]');
  if (!els.length) return;
  function show(el) { el.classList.add('is-in'); }
  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(els, show);
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { show(en.target); io.unobserve(en.target); }
    });
  }, { threshold: 0.2 });
  Array.prototype.forEach.call(els, function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-regalo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-jaspe-regalo]');
    if (!root) return;
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var tEl = root.querySelector('[data-jr-title]');
    var xEl = root.querySelector('[data-jr-text]');
    var SCENT_FB = root.dataset.scentFallback || '';
    var AROMAS = { '1':'Jazmín en Flor', '2':'Noble Petal', '3':'Pomelo', '4':'Vainilla', '5':'Ayurveda', '6':'Tropical' };

    function apply(titleKey, textKey, scent) {
      if (tEl && root.dataset[titleKey]) tEl.textContent = root.dataset[titleKey];
      if (xEl && root.dataset[textKey]) xEl.textContent = root.dataset[textKey].replace('{scent}', scent || SCENT_FB);
    }

    // --- One-tap: elección de aroma. SUB (?c=&s=&a=&r=&sig=) o NO-SUB (?c=&a=&r=&sig=&n=1) ---
    var c = params.get('c'), s = params.get('s'), a = params.get('a'), r = params.get('r'), sig = params.get('sig'), n = params.get('n');

    // SUB: tiene sub_id (s) → webhook del suscriptor (Task B inyecta en Loop)
    if (s && a && sig) {
      var aroma = AROMAS[a] || SCENT_FB;
      var hook = root.getAttribute('data-webhook') || '';
      if (hook) {
        try {
          fetch(hook, {
            method: 'POST', mode: 'no-cors',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'c=' + encodeURIComponent(c || '') + '&s=' + encodeURIComponent(s) + '&a=' + encodeURIComponent(a) + '&r=' + encodeURIComponent(r || '') + '&sig=' + encodeURIComponent(sig)
          });
        } catch (e) {}
      }
      apply('titleOk', 'textOk', aroma);
      return;
    }

    // NO-SUB: marcado con n=1, sin sub_id → webhook propio (Task NS-2 guarda la elección para Ana)
    if (n && a && sig) {
      var aromaN = AROMAS[a] || SCENT_FB;
      var hookN = root.getAttribute('data-webhook-nosub') || '';
      if (hookN) {
        try {
          fetch(hookN, {
            method: 'POST', mode: 'no-cors',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'c=' + encodeURIComponent(c || '') + '&a=' + encodeURIComponent(a) + '&r=' + encodeURIComponent(r || '') + '&sig=' + encodeURIComponent(sig) + '&n=1'
          });
        } catch (e) {}
      }
      apply('titleOk', 'textOk', aromaN);
      return;
    }

    // --- Modo clásico (?status=ok&scent=…), por si se usa vía redirect ---
    var status = (params.get('status') || params.get('ok') || '').toLowerCase();
    var scent = params.get('scent') || params.get('aroma') || '';
    if (status === 'ok' || status === '1' || status === 'true') {
      apply('titleOk', 'textOk', scent);
    } else if (status === 'error' || status === 'expired') {
      apply('titleError', 'textError', scent);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-resenas"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jrev]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.12 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-js-strip-bar]').forEach(function (bar) {
      var sec = bar.closest('.js-strip');
      if (!sec || !sec.classList.contains('js-strip--sticky')) return;
      var spacer = sec.querySelector('[data-js-strip-spacer]');
      var top = 0;
      function measure() { sec.classList.remove('js-strip--is-fixed'); if (spacer) spacer.style.height = '0px'; top = sec.getBoundingClientRect().top + window.pageYOffset; }
      function onScroll() {
        var fixed = window.pageYOffset >= top;
        sec.classList.toggle('js-strip--is-fixed', fixed);
        if (spacer) spacer.style.height = fixed ? bar.offsetHeight + 'px' : '0px';
      }
      measure(); onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measure(); onScroll(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-suscripcion"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-jsus]').forEach(function (r) {
    /* La pagina puede venir de cache de otro dia: se recalculan dia y mes con el reloj del cliente. */
    try {
      var idioma = document.documentElement.lang || 'es';
      var fm = new Intl.DateTimeFormat(idioma, { month: 'long' });
      r.querySelectorAll('[data-jsus-dias]').forEach(function (h) {
        var d = new Date(); d.setDate(d.getDate() + (parseInt(h.getAttribute('data-jsus-dias'), 10) || 0));
        var dia = h.querySelector('[data-jsus-dia]'), mes = h.querySelector('[data-jsus-mes]');
        if (dia) dia.textContent = d.getDate();
        if (mes) mes.textContent = fm.format(d);
      });
    } catch (e) {}
    r.classList.add('jsus--listo');
    if (!('IntersectionObserver' in window)) { r.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (e) {
      e.forEach(function (x) { if (x.isIntersecting) { r.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.3 });
    io.observe(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-ticket"] && !Shopify.designMode) return;
  try {
    
(function(){
  function euro(c){ return (c / 100).toFixed(2).replace('.', ','); }
  function cent(t){ var v = parseFloat(String(t || '').replace(/[^0-9,]/g, '').replace(',', '.')); return isNaN(v) ? 0 : Math.round(v * 100); }

  function init(sec){
    if (sec.dataset.jtkOn) return; sec.dataset.jtkOn = '1';
    var D = sec.dataset, papel = sec.querySelector('.jtk__papel') || sec;
    var reduce = !window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = 'IntersectionObserver' in window;
    var pend = false, mapa = {};
    try { mapa = JSON.parse(sec.querySelector('[data-jtk-mapa]').textContent); } catch(e){}
    /* Las fotos, relativas: el CDN de Shopify cuelga del mismo dominio de la tienda. */
    for (var id in mapa) if (mapa[id] && mapa[id].f) mapa[id].f = mapa[id].f.replace(/^(https?:)?\/\/[^\/]+/, '');

    /* ---- El gesto: imprimir. Se arma (papel escondido en la ranura) y sale al verse. ---- */
    function enVista(f){ var q = papel.getBoundingClientRect(); return q.top < window.innerHeight * (f || 1) && q.bottom > 0; }
    function sale(){ if (!pend) return; pend = false; sec.classList.add('is-in'); }
    function red(){ if (!pend) return; if (enVista()) setTimeout(sale, 3000); else setTimeout(red, 1000); }
    function arma(){
      if (reduce || !io) return;
      sec.classList.remove('is-in'); sec.classList.add('is-arm'); void sec.offsetWidth;
      pend = true; red();
    }
    if (io) new IntersectionObserver(function(es){ if (es[0].isIntersecting) sale(); }, { threshold: .25 }).observe(papel);
    /* Se observa el papel y no el ticket: el ticket esta fuera de la ranura mientras espera,
       y un elemento recortado nunca «entra» para el observador. */
    if (!enVista(.85)) arma();

    /* ---- El pedido de verdad, si arriba hay configurador ---- */
    function linea(foto, botella, nombre, precio, clase){
      var li = document.createElement('li');
      li.className = 'jtk__linea' + (foto ? ' jtk__linea--foto' : '') + (clase ? ' ' + clase : '');
      if (foto){
        var f = document.createElement('span'); f.className = 'jtk__foto' + (botella ? ' jtk__foto--botella' : '');
        var im = document.createElement('img'); im.src = foto; im.alt = ''; im.width = botella ? 20 : 48; im.height = 48; im.loading = 'lazy';
        f.appendChild(im); li.appendChild(f);
      }
      var nm = document.createElement('span'); nm.className = 'jtk__nombre'; nm.textContent = nombre; li.appendChild(nm);
      var pt = document.createElement('span'); pt.className = 'jtk__puntos'; li.appendChild(pt);
      var pr = document.createElement('span'); pr.className = 'jtk__precio'; pr.textContent = precio; li.appendChild(pr);
      return li;
    }
    function pon(sel, txt){ var e = sec.querySelector(sel); if (e) e.textContent = txt; }

    var completo = false, reimp = null;
    function pinta(d){
      if (!d) return;
      var pe = +D.pe, pb = +D.pb, pack = d.pack === 6 ? 6 : 3, sub = d.mode === 'sub', extra = Math.max(0, +d.extra || 0);
      var precio = cent(d.precio) || (sub ? (pack === 3 ? +D.ps3 : +D.ps6) : (pack === 3 ? pe * 3 : +D.pu6));
      var sel = (d.sel || []).filter(Boolean), fotos = [];
      for (var k in mapa) if (Object.prototype.hasOwnProperty.call(mapa, k)) fotos.push(mapa[k].f);

      var ul = sec.querySelector('[data-jtk-lineas]'); ul.textContent = '';
      for (var i = 0; i < pack; i++){
        var m = sel[i] && mapa[sel[i]];
        ul.appendChild(linea(m ? m.f : fotos[i % fotos.length], false, m ? m.n : D.tEsencia, euro(pe)));
      }
      ul.appendChild(linea(D.botella, true, D.tBotella, euro(pb)));
      if (extra) ul.appendChild(linea(D.botella, true, extra + ' × ' + D.tBotella, euro(pb * extra)));

      pon('[data-jtk-suma]', euro(pe * pack + pb * (1 + extra)));
      var menos = sec.querySelector('[data-jtk-menos]'), envio = menos.lastElementChild;
      menos.textContent = '';
      menos.appendChild(regalo.cloneNode(true));
      var desc = pe * pack - precio;
      if (desc > 0) menos.appendChild(linea(null, false, sub ? D.tSuscripcion : D.tPack6, '−' + euro(desc), 'jtk__linea--menos'));
      menos.appendChild(envio);

      pon('[data-jtk-total]', euro(precio + pb * extra) + ' €');
      pon('[data-jtk-luego]', sub ? D.tLuego.replace('PPP', euro(precio) + ' €').replace('NNN', pack) : D.tUnica);
      var sello = sec.querySelector('[data-jtk-sello]');
      if (sello){ sello.hidden = !sub; pon('[data-jtk-mes]', euro(Math.round(precio / 3)) + ' €'); }

      completo = sel.length >= pack;
      pon('[data-jtk-cta-t]', completo ? D.tSigue : D.tElige);

      /* Reimprime: al momento si se ve; si no, queda armado y sale al llegar. Con calma, que se toca seguido. */
      clearTimeout(reimp);
      reimp = setTimeout(function(){ arma(); if (enVista()) requestAnimationFrame(sale); }, enVista() ? 450 : 0);
    }
    var regalo = sec.querySelector('[data-jtk-menos] .jtk__linea--menos').cloneNode(true);
    document.addEventListener('jaspe:pack', function(e){ pinta(e.detail); });
    if (window.JaspePack) pinta(window.JaspePack);

    /* ---- El boton: si el configurador esta en esta pagina, se sube a el; si no, el enlace. ---- */
    var cta = sec.querySelector('[data-jtk-cta]');
    if (cta) cta.addEventListener('click', function(ev){
      var cfg = document.getElementById('esencias');
      if (!cfg) return;
      ev.preventDefault();
      var pagar = completo && cfg.querySelector('[data-jes-cta]:not([hidden])');
      var dest = pagar ? (cfg.querySelector('.jes__box') || pagar) : cfg;
      var y = dest.getBoundingClientRect().top + window.pageYOffset - (pagar ? window.innerHeight * .3 : 60);
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      if (pagar) setTimeout(function(){ try { pagar.focus({ preventScroll: true }); } catch(e){} }, reduce ? 0 : 700);
    });
  }
  document.querySelectorAll('[data-jtk]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-jact]').forEach(function (root) {
    // Reveal
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.12 });
      io.observe(root);
    } else { root.classList.add('is-in'); }

    // Flechas
    var rail = root.querySelector('[data-jact-rail]');
    var prev = root.querySelector('[data-jact-prev]');
    var next = root.querySelector('[data-jact-next]');
    if (rail && prev && next) {
      var step = function () { return Math.round(rail.clientWidth * 0.8); };
      prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    }

    // Autoplay en viewport (pausa fuera) + primer fotograma siempre visible + sonido exclusivo
    var vids = root.querySelectorAll('[data-jact-video]');
    if (!vids.length) return;

    // Refuerzo: en Android/WebView #t=0.1 a veces no pinta -> forzar el primer frame una vez
    vids.forEach(function (v) {
      v.addEventListener('loadeddata', function () {
        if (!v.dataset.seeked) { try { v.currentTime = 0.1; } catch (e) {} v.dataset.seeked = '1'; }
      });
    });

    // Sonido: solo una tarjeta con audio a la vez (mantiene muted-first => autoplay intacto)
    function jactMuteAll(except) {
      root.querySelectorAll('[data-jact-sound]').forEach(function (btn) {
        if (btn === except) return;
        var card = btn.closest('.jact__card');
        var vv = card && card.querySelector('[data-jact-video]');
        if (vv) vv.muted = true;
        btn.classList.remove('is-on');
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Activar sonido');
      });
    }
    root.querySelectorAll('[data-jact-sound]').forEach(function (btn) {
      var card = btn.closest('.jact__card');
      var v = card && card.querySelector('[data-jact-video]');
      if (!v) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var turningOn = !btn.classList.contains('is-on');
        jactMuteAll(btn);
        if (turningOn) {
          v.muted = false; v.volume = 1;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
          btn.classList.add('is-on'); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Silenciar');
        } else {
          v.muted = true;
          btn.classList.remove('is-on'); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Activar sonido');
        }
      });
    });

    if (reduce || !('IntersectionObserver' in window)) return; // sin autoplay: queda el primer fotograma (#t=0.1)

    function jactResetSound(v) {
      if (v.muted) return;
      v.muted = true;
      var card = v.closest('.jact__card');
      var btn = card && card.querySelector('[data-jact-sound]');
      if (btn) { btn.classList.remove('is-on'); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Activar sonido'); }
    }

    // Warm: precarga el clip de las tarjetas a punto de entrar (no los 8 a la vez)
    var warm = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting && en.target.preload !== 'auto') en.target.preload = 'auto'; });
    }, { root: rail, rootMargin: '0px 200px 0px 200px', threshold: 0 });
    vids.forEach(function (v) { warm.observe(v); });

    // Play: arranca antes de estar 100% centrada y pausa al salir lateralmente
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); jactResetSound(v); }
      });
    }, { root: rail, rootMargin: '0px -10% 0px -10%', threshold: 0.35 });
    vids.forEach(function (v) { vio.observe(v); });

    // Sección fuera de vista VERTICAL: el IO de play (vio) usa root:rail y solo reacciona
    // al scroll HORIZONTAL, así que no detecta el scroll vertical. Al SALIR pausamos todos;
    // al VOLVER hay que REANUDAR el/los vídeo(s) centrados en el rail (antes solo pausaba y
    // nada los reanudaba → había que hacer swipe lateral para reactivarlos).
    function jactPlayVisible() {
      if (!rail || !rail.offsetParent) { vids.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }); return; }
      var rr = rail.getBoundingClientRect();
      vids.forEach(function (v) {
        var vr = v.getBoundingClientRect();
        var cx = vr.left + (vr.width / 2);
        if (cx > rr.left && cx < rr.right) { // centro del vídeo dentro del rail visible
          v.preload = 'auto';
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        }
      });
    }
    var secIO = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { jactPlayVisible(); }
        else { vids.forEach(function (v) { v.pause(); jactResetSound(v); }); }
      });
    }, { threshold: 0.01 });
    secIO.observe(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
